export default {
  loadingMessage: 'Loading...'
};
